import React, { useEffect, useState } from "react";
import { FiSettings } from "react-icons/fi";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

function AddNewState() {
  const params = useParams();
  const [languageData, setLanguageData] = useState();
  const [country, setCountry] = useState();

  const [initialVal, setInitialVal] = useState({
    state: "",
    is_default: 1,
    is_active: 1,
    sort_order: 0,

    country_id: "",
    // language_id: "",
  });
  console.log(initialVal);
  const navigate = useNavigate();

  const getLanguageData = async () => {
    try {
      const resLang = await axios.get(
        `https://abarishr.hennainternational.in/api/language`
      );
      setLanguageData(resLang.data);

      const resCountry = await axios.get(
        `https://abarishr.hennainternational.in/api/countries/public`
      );
      setCountry(resCountry.data?.data);
    } catch (error) {
      alert("wrog");
    }
  };

  const changeHandler = (e) => {
    const clone = { ...initialVal };
    const value = e.target.value;

    const name = e.target.name;
    console.log(e.target.name);
    clone[name] = value;
    setInitialVal(clone);
  };

  const getById = async (id) => {
    const res = await axios.get(
      `https://abarishr.hennainternational.in/api/states/get/${params?.id}`
    );
    const clone = {
      ...res.data,
      country_id: res.data.country_id,
      // language_id: res.data.language_id,
    };
    setInitialVal(clone);
  };

  useEffect(() => {
    getLanguageData();
    if (params?.id) {
      getById();
    }
  }, []);

  const notify = (updateMassage) => toast(updateMassage);

  const handleAdd = async () => {
    try {
      const res = await axios.post(
        `https://abarishr.hennainternational.in/api/states/add`,
        initialVal
      );
      notify("Add Successfull");
      setTimeout(() => {
        navigate("/admin/list-states");
      }, 1000);
    } catch (error) { }
  };

  const updateHandle = async () => {
    try {
      const res = await axios.put(
        `https://abarishr.hennainternational.in/api/states/update/${params.id}`,
        initialVal
      );
      notify("update Successfull");
      setTimeout(() => {
        navigate("/admin/list-states");
      }, 1000);
    } catch (error) { }
  };

  return (
    <>
      <div className="pageTableWrapper">
        <ToastContainer />
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>State form</h5>
          </div>
        </div>

        <div className="pageBody">
          <div className="pageTable">
            <form>
              {/* <div className="form-group mb-3">
                <label htmlFor="lang" className="mb-1">
                  <strong>Language</strong>
                </label>
                <select
                  className="form-select"
                  name="language_id"
                  onChange={changeHandler}
                  value={initialVal?.language_id?._id}
                >
                  <option selected>Select Language</option>
                  {languageData &&
                    languageData?.map((item) => {
                      return <option value={item._id}>{item?.lang}</option>;
                    })}
                </select>
              </div> */}
              <div className="form-group mb-3">
                <label htmlFor="lang" className="mb-1">
                  <strong>Country</strong>
                </label>
                <select
                  className="form-select"
                  onChange={changeHandler}
                  name="country_id"
                  value={initialVal?.country_id}
                >
                  <option selected>Select Country</option>
                  {country &&
                    country?.map((item) => {
                      return <option value={item?._id}>{item?.country}</option>;
                    })}
                </select>
              </div>
              <div className="form-group mb-3">
                <label htmlFor="language_level">
                  <strong>State</strong>
                </label>
                <input
                  className="form-control"
                  id="language_level"
                  placeholder="State"
                  type="text"
                  name="state"
                  value={initialVal?.state}
                  onChange={changeHandler}
                />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="is_default">
                  <strong>Is Default?</strong>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_default"
                    value={1}
                    checked={Number(initialVal?.is_default) === 1}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_default_yes">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_default"
                    value={0}
                    checked={Number(initialVal?.is_default) === 0}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_default_no">
                    No
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="is_active">
                  <strong>Active</strong>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_active"
                    value={1}
                    checked={Number(initialVal?.is_active) === 1}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_active_yes">
                    Active
                  </label>
                </div>
                <div className="form-check mt-1 mb-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_active"
                    value={0}
                    checked={Number(initialVal?.is_active) === 0}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_active_no">
                    Inactive
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="pageFooter text-center mt-2">
          <button
            className="btn btn-large btn-primary"
            type="button"
            onClick={params.id ? updateHandle : handleAdd}
          >
            Update <BsFillArrowRightCircleFill />
          </button>
        </div>
      </div>
    </>
  );
}
export default AddNewState;
